document.addEventListener("DOMContentLoaded", function () {

    /* ==========================================
        Gallery Auto Play & Swiper Synchronization
    ========================================== */

    const mainImage = document.getElementById("LoginMainImage");
    const thumbs = document.querySelectorAll(".login-thumb");
    let currentThumb = 0;
    let autoPlayTimer = null;

    if (thumbs.length > 0 && document.querySelector(".loginThumbsSwiper")) {
        
        window.thumbsSwiper = new Swiper(".loginThumbsSwiper", {
            slidesPerView: 5,
            spaceBetween: 12,
            speed: 400,
            centeredSlides: false,
            watchSlidesProgress: true,
            observer: true,
            observeParents: true,
            breakpoints: {
                0: { 
                    slidesPerView: 4, 
                    spaceBetween: 8 
                },
                768: { 
                    slidesPerView: 5, 
                    spaceBetween: 12,
                    slidesPerGroup: 1
                }
            },
            on: {
                init: function () {
                    this.update();
                }
            }
        });

        function getVisibleThumbs() {
            return Array.from(document.querySelectorAll(".login-thumb")).filter(
                t => t.style.display !== "none" && 
                     !t.classList.contains("swiper-slide-hidden") && 
                     !t.classList.contains("swiper-slide-duplicate")
            );
        }

        function setActiveThumb(index) {
            const visibleThumbs = getVisibleThumbs();
            if (index < 0 || index >= visibleThumbs.length) return;
            
            currentThumb = index;
            thumbs.forEach(item => item.classList.remove("active"));
            
            const activeThumb = visibleThumbs[currentThumb];
            if (activeThumb) {
                activeThumb.classList.add("active");
                
                if (mainImage && activeThumb.dataset.image) {
                    mainImage.src = activeThumb.dataset.image;
                }
            }

            if (window.thumbsSwiper && window.thumbsSwiper.initialized) {
                const realIndex = Array.from(thumbs).indexOf(activeThumb);
                if (realIndex !== -1) {
                    window.thumbsSwiper.slideTo(realIndex);
                }
            }
        }

        function startAutoPlay() {
            if (autoPlayTimer) clearInterval(autoPlayTimer);

            autoPlayTimer = setInterval(() => {
                const visibleThumbs = getVisibleThumbs();
                if (visibleThumbs.length <= 1) return;
                
                let nextIndex = (currentThumb + 1) % visibleThumbs.length;
                setActiveThumb(nextIndex);
            }, 5000);
        }

        thumbs.forEach((thumb) => {
            thumb.addEventListener("click", function (e) {
                e.preventDefault();
                const visibleThumbs = getVisibleThumbs();
                const clickIndex = visibleThumbs.indexOf(this);
                if (clickIndex !== -1) {
                    setActiveThumb(clickIndex);
                    startAutoPlay();
                }
            });
        });

        startAutoPlay();
    }

    /* ==========================================
        Zero Lifestyle Style Image Filtering Logic
    ========================================== */

    function filterImagesByColor(selectedColor) {
        if (!selectedColor) return;
        
        const targetColor = selectedColor.toString().toLowerCase().replace(/[^a-z0-9]/g, "").trim();
        const allThumbs = document.querySelectorAll(".login-thumb");
        let firstMatch = null;

        allThumbs.forEach((thumb) => {
            const thumbAlt = (thumb.dataset.alt || "").toString().toLowerCase().replace(/[^a-z0-9]/g, "").trim();
            const thumbOption = (thumb.dataset.option1 || "").toString().toLowerCase().replace(/[^a-z0-9]/g, "").trim();
            const thumbColor = (thumb.dataset.color || "").toString().toLowerCase().replace(/[^a-z0-9]/g, "").trim();

            const isMatch = thumbAlt.includes(targetColor) || 
                            targetColor.includes(thumbAlt) || 
                            thumbOption === targetColor || 
                            thumbColor === targetColor || 
                            thumbAlt === "" || 
                            thumbAlt === "all";

            if (isMatch) {
                thumb.style.setProperty("display", "block", "important");
                thumb.classList.remove("swiper-slide-hidden");
                if (!firstMatch) firstMatch = thumb;
            } else {
                thumb.style.setProperty("display", "none", "important");
                thumb.classList.add("swiper-slide-hidden");
            }
        });

        if (window.thumbsSwiper && window.thumbsSwiper.initialized) {
            window.thumbsSwiper.updateSlides();
            window.thumbsSwiper.updateProgress();
            window.thumbsSwiper.updateSlidesClasses();
            window.thumbsSwiper.slideTo(0);
        }

        if (firstMatch) {
            allThumbs.forEach(t => t.classList.remove("active"));
            firstMatch.classList.add("active");
            currentThumb = 0;
            
            if (mainImage && firstMatch.dataset.image) {
                mainImage.src = firstMatch.dataset.image;
            }
        }
    }

    /* ==========================================
        Quantity
    ========================================== */

    const qty = document.getElementById("LoginQty");
    if (qty) {
        document.querySelector(".qty-plus")?.addEventListener("click", function () {
            qty.value = parseInt(qty.value || 1) + 1;
        });

        document.querySelector(".qty-minus")?.addEventListener("click", function () {
            if (parseInt(qty.value || 1) > 1) {
                qty.value = parseInt(qty.value) - 1;
            }
        });
    }

    /* ==========================================
        Variant Engine & Universal Event Delegation
    ========================================== */

    const jsonEl = document.getElementById("LoginProductJson");
    if (jsonEl) {
        const productJSON = JSON.parse(jsonEl.textContent);
        const priceEl = document.getElementById("LoginProductPrice");
        const compareEl = document.getElementById("LoginComparePrice");
        const variantInput = document.getElementById("LoginVariantId");

        function getSelectedOptions() {
            const selected = [];
            productJSON.options.forEach((optionName, index) => {
                const checked = document.querySelector(`input[name="option${index + 1}"]:checked`) ||
                                document.querySelector(`input[name="${optionName}"]:checked`) ||
                                document.querySelector(`input[name="Option${index + 1}"]:checked`) ||
                                document.querySelector(`select[name="option${index + 1}"]`);
                
                selected.push(checked ? checked.value : null);
            });
            return selected;
        }

        function findVariant() {
            const selected = getSelectedOptions();
            return productJSON.variants.find(variant => {
                return variant.options.every((value, index) => {
                    return selected[index] === null || value.toString().trim() === selected[index].toString().trim();
                });
            });
        }

        function updateVariant() {
            const variant = findVariant();
            if (!variant) return;

            if (variantInput) variantInput.value = variant.id;

            if (priceEl) {
                priceEl.textContent = "Rs." + (variant.price / 100).toLocaleString("en-PK");
            }

            if (compareEl) {
                if (variant.compare_at_price > variant.price) {
                    compareEl.style.display = "";
                    compareEl.textContent = "Rs." + (variant.compare_at_price / 100).toLocaleString("en-PK");
                } else {
                    compareEl.style.display = "none";
                }
            }

            const selectedColor = variant.option1 || variant.options[0];
            if (selectedColor) {
                filterImagesByColor(selectedColor);
            }
        }

        document.addEventListener("change", function (e) {
            if (e.target.closest('.login-option-input, input[type="radio"], select, .swatch-input')) {
                updateVariant();
            }
        });

        document.addEventListener("click", function (e) {
            const swatch = e.target.closest('.swatch, .color-swatch, [data-option-value]');
            if (swatch) {
                setTimeout(updateVariant, 50);
            }
        });

        updateVariant();
    }

    /* ==========================================
        Scroll Video Scrubbing
    ========================================== */

    const section = document.querySelector(".product-scroll-video-section");
    if (section) {
        const video = section.querySelector("video");
        if (video) {
            let targetProgress = 0;
            let currentProgress = 0;
            let touchStartY = 0;
            let ticking = false;

            const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

            const getNaturalProgress = () => {
                const rect = section.getBoundingClientRect();
                const totalScroll = section.offsetHeight - window.innerHeight;
                if (totalScroll <= 0) return 0;
                return clamp((-rect.top / totalScroll), 0, 1);
            };

            const isSectionPinned = () => {
                const rect = section.getBoundingClientRect();
                return rect.top <= 0 && rect.bottom > window.innerHeight;
            };

            const render = () => {
                ticking = false;
                currentProgress += (targetProgress - currentProgress) * 0.16;
                currentProgress = clamp(currentProgress, 0, 1);

                if (video.duration) {
                    const nextTime = video.duration * currentProgress;
                    if (Math.abs(video.currentTime - nextTime) > 0.03) {
                        video.currentTime = nextTime;
                    }
                }

                if (Math.abs(targetProgress - currentProgress) > 0.001) {
                    ticking = true;
                    requestAnimationFrame(render);
                }
            };

            const requestRender = () => {
                if (!ticking) {
                    ticking = true;
                    requestAnimationFrame(render);
                }
            };

            const handleInput = (deltaY, event) => {
                if (!video.duration || !isSectionPinned()) return;
                const movingForward = deltaY > 0 && targetProgress < 1;
                const movingBackward = deltaY < 0 && targetProgress > 0;

                if (movingForward || movingBackward) {
                    event.preventDefault();
                    targetProgress = clamp(targetProgress + (deltaY * 0.0009), 0, 1);
                    requestRender();
                }
            };

            const syncFromPageScroll = () => {
                if (!video.duration) return;
                if (!isSectionPinned()) {
                    targetProgress = getNaturalProgress();
                    requestRender();
                }
            };

            const init = () => {
                video.pause();
                video.currentTime = 0;
                video.playbackRate = 1;
                targetProgress = getNaturalProgress();
                currentProgress = targetProgress;
                requestRender();
            };

            if (video.readyState >= 1) {
                init();
            } else {
                video.addEventListener("loadedmetadata", init, { once: true });
            }

            window.addEventListener("scroll", syncFromPageScroll, { passive: true });
            window.addEventListener("wheel", (e) => handleInput(e.deltaY, e), { passive: false });
            section.addEventListener("touchstart", (e) => { touchStartY = e.touches[0].clientY; }, { passive: true });
            section.addEventListener("touchmove", (e) => {
                const currentY = e.touches[0].clientY;
                const deltaY = touchStartY - currentY;
                touchStartY = currentY;
                handleInput(deltaY, e);
            }, { passive: false });
            window.addEventListener("resize", syncFromPageScroll);
        }
    }

    /* ==========================================
        Tabs Navigation & Active Highlighting
    ========================================== */

    const navLinks = document.querySelectorAll('.product-tab-nav .tab-link');
    const sections = document.querySelectorAll('.tab-section-block');

    if (navLinks.length > 0) {
        navLinks.forEach(link => {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                
                navLinks.forEach(l => l.classList.remove('active'));
                this.classList.add('active');

                const targetId = this.getAttribute('href');
                const targetElement = document.querySelector(targetId);
                if (targetElement) {
                    const headerOffset = 100;
                    const elementPosition = targetElement.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            });
        });

        let scrollTimeout;
        window.addEventListener('scroll', () => {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                let current = '';
                sections.forEach(section => {
                    const sectionTop = section.offsetTop - 140;
                    if (window.pageYOffset >= sectionTop) {
                        current = section.getAttribute('id');
                    }
                });

                if (current) {
                    navLinks.forEach(link => {
                        if (link.getAttribute('href') === '#' + current) {
                            navLinks.forEach(l => l.classList.remove('active'));
                            link.classList.add('active');
                        }
                    });
                }
            }, 500);
        }, { passive: true });
    }
});





document.addEventListener('DOMContentLoaded', function () {

  const navigation = document.querySelector('.login-product-navigation');

  if (!navigation) return;

  const tabs = navigation.querySelectorAll('.login-product-nav-item');


  /* =====================================================
     CLICK
  ===================================================== */

  tabs.forEach(function (tab) {

    tab.addEventListener('click', function (event) {

      const targetId = this.getAttribute('data-target');

      const target = document.getElementById(targetId);

      if (!target) return;

      event.preventDefault();


      tabs.forEach(function (item) {
        item.classList.remove('is-active');
      });

      this.classList.add('is-active');


      const offset = 90;

      const targetPosition =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        offset;


      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });

    });

  });


  /* =====================================================
     SCROLL ACTIVE TAB
  ===================================================== */

  const sections = [
    {
      id: 'tab-features',
      tab: navigation.querySelector('[data-target="tab-features"]')
    },
    {
      id: 'tab-specs',
      tab: navigation.querySelector('[data-target="tab-specs"]')
    },
    {
      id: 'tab-reviews',
      tab: navigation.querySelector('[data-target="tab-reviews"]')
    },
    {
      id: 'tab-faqs',
      tab: navigation.querySelector('[data-target="tab-faqs"]')
    }
  ];


  const observer = new IntersectionObserver(
    function (entries) {

      entries.forEach(function (entry) {

        if (!entry.isIntersecting) return;

        const sectionId = entry.target.id;

        const matched = sections.find(function (item) {
          return item.id === sectionId && item.tab;
        });

        if (!matched) return;

        tabs.forEach(function (tab) {
          tab.classList.remove('is-active');
        });

        matched.tab.classList.add('is-active');

      });

    },
    {
      root: null,
      rootMargin: '-25% 0px -60% 0px',
      threshold: 0
    }
  );


  sections.forEach(function (item) {

    const section = document.getElementById(item.id);

    if (section) {
      observer.observe(section);
    }

  });

});



/* ==========================================
    Read More / Show Less Specifications Toggle
========================================== */

window.toggleSpecs = function () {
    const specTable = document.querySelector(".spec-table");
    const btn = document.getElementById("specToggleBtn") || document.querySelector(".spec-toggle-btn");
    
    if (!specTable || !btn) return;

    // Toggle .expanded class on the specification table container
    specTable.classList.toggle("expanded");

    const isExpanded = specTable.classList.contains("expanded");

    if (isExpanded) {
        btn.textContent = "Read Less";
        btn.setAttribute("data-expanded", "true");
    } else {
        btn.textContent = "Read More";
        btn.setAttribute("data-expanded", "false");
    }
};